import React, { useState, useEffect } from 'react';

// components
import Toggle from '../Toggle/Toggle';

function ToggleSetting(props: {
    name: string;
    initialToggleState: boolean;
    onToggle?: (state: boolean) => void;
}) {
    let [isOn, setIsOn] = useState(props.initialToggleState);
    
    useEffect(() => {
        if (props.onToggle) {
            props.onToggle(isOn);
        }
    }, [isOn, props]);
    
    return (
        <div className="mb-5">
            <Toggle initialToggleState={props.initialToggleState} onToggle={setIsOn}>{props.name}</Toggle>
        </div>
    );
}
export default ToggleSetting;